import React from "react";
import { FinancialItem } from "../../models/FinancialItem";

interface Props {
  items: FinancialItem[];
}

const FinancialStatsSummary: React.FC<Props> = ({ items }) => {
  const totalAssets = items
    .filter((item) => item.category === "asset")
    .reduce((sum, item) => sum + (item.amount ?? 0), 0);

  const totalDebts = items
    .filter((item) => item.category === "debt")
    .reduce((sum, item) => sum + (item.amount ?? 0), 0);

  const netEquity = totalAssets - totalDebts;

  const spouseATotal = items.reduce((sum, item) => {
    const net = (item.amount ?? 0) - (item.associatedDebtAmount ?? 0);
    return sum + net * (item.ownershipPercentage / 100);
  }, 0);

  const spouseBTotal = items.reduce((sum, item) => {
    const net = (item.amount ?? 0) - (item.associatedDebtAmount ?? 0);
    return sum + net * ((100 - item.ownershipPercentage) / 100);
  }, 0);

  return (
    <div className="p-6 mb-8 bg-white border shadow-sm rounded-2xl dark:bg-zinc-900">
      {/* First Row: 3 items */}
      <div className="grid grid-cols-1 gap-6 mb-6 sm:grid-cols-2 md:grid-cols-3">
        <StatCard title="Total Assets" value={totalAssets} />
        <StatCard title="Total Debts" value={totalDebts} />
        <StatCard title="Net Equity" value={netEquity} />
      </div>

      {/* Second Row: 2 items */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <StatCard title="Your Total" value={spouseATotal} />
        <StatCard title="Their Total" value={spouseBTotal} />
      </div>
    </div>
  );
};

interface StatCardProps {
  title: string;
  value: number;
}

const StatCard: React.FC<StatCardProps> = ({ title, value }) => {
  return (
    <div className="flex flex-col p-4 border shadow-sm rounded-xl bg-muted/20 dark:bg-muted/10">
      <span className="text-sm font-medium text-muted-foreground">{title}</span>
      <span className="text-2xl font-bold">
        {value.toLocaleString("en-US", { style: "currency", currency: "USD" })}
      </span>
    </div>
  );
};

export default FinancialStatsSummary;
